// extracted by mini-css-extract-plugin
export var renderWrapper = "b_b";
export var renderContainer = "b_c";
export var tabletContainer = "b_d";